__turbopack_context__.v({
  "companyLogo": "branding-module__4bunGG__companyLogo",
  "companyName": "branding-module__4bunGG__companyName",
  "companySlogan": "branding-module__4bunGG__companySlogan",
  "footerBranding": "branding-module__4bunGG__footerBranding",
  "topBarBranding": "branding-module__4bunGG__topBarBranding",
});
